import '@/assets/scss/breadcrumb.scss';
export default {
    props: ['width'],
    data() {
        return {

        }
    },
    computed: {
        user(){
            return this.$store.state.user;
        },
        breadcrumb(){
            return this.$store.state.breadcrumb ? this.$store.state.breadcrumb : [];
        }
    },
    methods: {
        goLink(item){
            if(item.href){
                location.href = item.href;
            }else{
                this.$router.push({
                    name: item.name,
                });
            }
        }
    },
    render(h){
        let dom = this.breadcrumb.map((item, index) => {
            if(!item.path && !item.href){
                return <li>{item.title}</li>
            }else{
                return <li class="has-path" onClick={() => this.goLink(item)}
                    >{item.title}</li>
            }
        })
        return (
            <div class="d-flex header-dashboard-pc" style={'width: calc(100% - ' + this.width + 'px)'}>
                <div class="breadcrumb-header-pc">
                    <ul class="breadcrumb-vatgia">
                        {dom}
                    </ul>
                </div>
                <div class="avatar-breadcrumb d-flex justify-content-end position-relative">
                    <div class="info-user">
                        <div class="avatar">
                            <img src={this.user.avatar ? this.user.avatar.medium : this.$urlImage('/images/example_avatar.svg')}
                                onError={this.$errorAvatar}/>
                        </div>
                        <div class="user">
                            {
                                this.user.name ? this.user.name : (this.user.email)
                            }
                        </div>
                    </div>
                    <div class="dropdown-avatar">
                        <ul>
                            {/*<li>*/}
                            {/*    <a href="https://vatgia.com/">Trang sản phẩm</a>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <a href="https://vatgia.com/hoidap">Trang hỏi đáp</a>*/}
                            {/*</li>*/}
                            <li>
                                <a href="https://vatgia.com/raovat">Trang rao vặt</a>
                            </li>
                            <li onclick={() => this.$logout()}>Đăng xuất</li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
